import { render } from "./DataTableList.vue?vue&type=template&id=7410a4dc&scoped=true"
import script from "./DataTableList.vue?vue&type=script&lang=js"
export * from "./DataTableList.vue?vue&type=script&lang=js"

import "./DataTableList.vue?vue&type=style&index=0&id=7410a4dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7410a4dc"]])

export default __exports__